<template>
  <div class="exchange-detail detail-padding padding-nav">
    <el-button
      @click="goback"
      type="text"
      class="upper"
      style="margin-bottom:0.16rem;"
      icon="el-icon-d-arrow-left"
      >Go back</el-button
    >
    <div class="spaceBetween" style="margin-bottom:0.24rem">
      <div class="spaceLeft">
        <div class="detail-title-1">Bid details</div>
      </div>
    </div>
    <div class="common-card">
      <div class="spaceLeft">
        <div class="detail-title-2">Bid No. {{pageData.number}}</div>
        <div class="status-title" :class="{'status-ing':pageData.status!=3,'status-over':isOver(pageData.overtime)}">{{statusMap["status_" + (isOver(pageData.overtime)?"3":pageData.status)]}}</div>
      </div>
      <el-row>
        <template v-if="pageData.status!=3">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-col :span="24">
              <div class="detail-item spaceLeft">
                <span class="detail-item-label">Starting time:</span>
                <span>{{moment.utc(pageData.startTime).format("YYYY-MM-DD HH:mm:ss")}}</span>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="detail-item spaceLeft">
                <span class="detail-item-label">Closing time:</span>
                <span>{{moment.utc(pageData.overtime).format("YYYY-MM-DD HH:mm:ss")}}</span>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="detail-item spaceLeft">
                <span class="detail-item-label">Auction:</span>
                <span><big-number :number="pageData.amount"/></span>
                <span class="unit">UNIT</span>
                <span
                  class="status spaceLeft"
                  :class="getTranfer(pageData.status).class"
                  v-if="pageData.status==3"
                >
                  <i class="iconfont" :class="getTranfer(pageData.status).icon" />
                  {{ getTranfer(pageData.status).text }}
                </span>
                <span style="font-size:0.15rem; color:#fff;" v-if="pageData.status==3">{{moment.utc(pageData.timestamp).format("YYYY-MM-DD HH:mm:ss")}}</span>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="detail-item spaceLeft">
                <span class="detail-item-label">Reserve price:</span>
                <span><big-number :number="pageData.startAmount"/></span>
                <span class="unit">TCash</span>
              </div>
            </el-col>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-col :span="24">
              <div class="detail-item spaceLeft" style="margin:0">
                <place-bid-time :needHideTips="true" :closeTime.sync="pageData.overtime"/>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="detail-item spaceLeft" style="margin-top: 0.5rem;">
                <span class="detail-item-label">My bid price:</span>
                <span><big-number :number="pageData.myBid"/></span>
                <span class="unit">TCash</span>
                <el-button @click="openMyBidDetail" size="min" type="text" style="margin-left:0.24rem;color: #2675F1!important;font-size: 0.16rem;" >Details <i class="el-icon el-icon-arrow-right"></i></el-button
                >
              </div>
            </el-col>
          </el-col>
        </template>

        <template v-if="isOver(pageData.overtime)">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">Starting time:</span>
              <span>{{moment.utc(pageData.startTime).format("YYYY-MM-DD HH:mm:ss")}}</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">Closing time:</span>
              <span>{{moment.utc(pageData.overtime).format("YYYY-MM-DD HH:mm:ss")}}</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">Auction:</span>
              <span><big-number :number="pageData.amount"/></span>
              <span class="unit">UNIT</span>
              <span
                class="status spaceLeft"
                :class="getTranfer(pageData.status).class"
                v-if="pageData.status==3"
              >
                <i class="iconfont" :class="getTranfer(pageData.status).icon" />
                {{ getTranfer(pageData.status).text }}
              </span>
              <span style="font-size:0.15rem; color: #929DAD;" v-if="pageData.status==3">{{moment.utc(pageData.timestamp).format("YYYY-MM-DD HH:mm:ss")}}</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">My bid price:</span>
              <span><big-number :number="pageData.myBid"/></span>
              <span class="unit">TCash</span>
              <el-button @click="openMyBidDetail" size="min" type="text" style="margin-left:0.24rem;color: #2675F1!important;font-size: 0.16rem;" >Details <i class="el-icon el-icon-arrow-right"></i></el-button>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">Reserve price:</span>
              <span><big-number :number="pageData.startAmount"/></span>
              <span class="unit">TCash</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">Winning price:</span>
              <span><big-number :number="pageData.highValue"/></span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">Winning bidder:</span>
              <span class="unit"><account :value="pageData.winner||'--'"/></span>
            </div>
          </el-col>
        </template>

      </el-row>
    </div>
    <div class="common-card">
      <div class="detail-title-2">All Bids</div>
      <el-table
        class="common-table"
        :data="tableList"
        v-loading="loading"
        highlight-current-row
      >
        <el-table-column prop="data1" label="" align="right" width="50px">
         <template slot-scope="{ $index }">
            {{ queryParams.total - ((queryParams.page - 1) * queryParams.pageSize + $index) }}
          </template>
        </el-table-column>
        <el-table-column prop="account" label="Bidder" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <account :value="row.account"/>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="Bid Price" align="right">
          <template slot-scope="{ row }">
            <big-number :number="row.amount"/><span class="td-word-sm">TCash</span>
          </template>
        </el-table-column>
        <el-table-column prop="timestamp" label="Bidding Time" align="center">
          <template slot-scope="{ row }">
            {{ moment.utc(row.timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total.sync="queryParams.total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.pageSize"
        @pagination="getList()"
      />
    </div>
    <detailBidsDialog ref="detailBidsDialog"/>
  </div>
</template>

<script>
import detailBidsDialog from "./detailBidsDialog.vue"
import placeBidTime from "../components/placeBidTime.vue"
import { auctionDetailList } from "@/api/auction.js"
export default {
  components: { detailBidsDialog, placeBidTime },
  data() {
    return {
      loading: false,
      pageData: {},
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      tableList: [],
      statusMap:this.$store.getters.auctionStatusMap
    };
  },
  computed: {},
  methods: {
    init(){
      this.pageData = { ...this.$route.query};
    },
    getList() {
      this.loading = true;
      auctionDetailList({
        pageSize:this.queryParams.pageSize,
        page:this.queryParams.page,
        number:this.pageData.number,
      }).then(res => {
        this.tableList = res.data ? res.data.data : [];
        this.queryParams.total = res.data.total || 0;
        this.loading = false;
      }).catch(e => {
        this.loading = false;
      })
    },
    getTranfer(val) {
      switch (+val) {
        case 3:
          return { text: "Extracted", class: "status-3", icon: "trn-xiaohao" };
        default:
          return { text: "To extract", class: "status-1", icon: "trn-tiqu" };
      }
    },
    isOver(overtime){
      return new Date(overtime).getTime() <= new Date().getTime();
    },
    openMyBidDetail(){
      this.$refs.detailBidsDialog.open({number:this.pageData.number});
    },
    goback() {
      this.$router.push("/TCashFinance/auction/placeBid/record");
    }
  },
  created() {
    this.init();
    this.getList();
  },
  mounted() {}
};
</script>
<style scoped lang="scss">
.unit {
  font-size: 0.16rem;
  font-weight: 500;
  color: #929dad;
  margin-left: 0.04rem;
}
.detail-padding {
  padding-left: 10%;
  padding-right: 10%;
}
.common-card {
  //background: #fff;
  border-radius: 0.08rem;
  padding: 0.32rem 0.24rem;
  box-shadow: 0px 12px 28px 0px rgba(6, 16, 32, 0.05);
  margin-bottom: 0.2rem;
}

.exchange-detail {
  .td-type-img {
    width: 0.52rem;
    margin-right: 0.16rem;
  }
}
.detail-title-2 {
  color: #fff;
  margin-bottom: 0.12rem;
}
.status-title{
  font-size: 0.18rem;
  font-weight: 400;
  color: #FFFFFF;
  padding:0.04rem 0.16rem 0.04rem 0.1rem;
  margin:0 0 0.12rem 0.16rem;

  &.status-ing{
    background:url("../../../../../assets/image/placeBid/ing.png")no-repeat;
    background-size:100% 100%;

  }
  &.status-over{
    background:url("../../../../../assets/image/placeBid/over.png")no-repeat;
    background-size:100% 100%;
  }
}
.status {
  border-radius: 0.04rem;
  color: #1f1f1f;
  padding: 0 0.12rem;
  font-size: 0.2rem;
  color: #3172fd;
  margin-left: 0.49rem;
  i {
    color: #3172fd;
    margin-right: 0.04rem;
  }
  &.status-3 {
    color: #fff;
    i {
      color: #2e9571;
    }
  }
}

.detail-item {
  color: #fff;
  font-size: 0.2rem;
  font-weight: 500;

  .detail-item-label {
    color: rgba(255, 255, 255, .7);
  }
}

.common-table {
  >>> .el-loading-mask {
    background-color: rgba(0, 0, 0, .6);
  }

  >>> .el-loading-spinner .path {
    stroke: #2675f1;
  }
}
</style>
